import { render, staticRenderFns } from "./PlaceContent.vue?vue&type=template&id=1c95e528&scoped=true"
import script from "./PlaceContent.vue?vue&type=script&lang=js"
export * from "./PlaceContent.vue?vue&type=script&lang=js"
import style0 from "./PlaceContent.vue?vue&type=style&index=0&id=1c95e528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c95e528",
  null
  
)

export default component.exports